import script from "./AlphabetFilterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AlphabetFilterComponent.vue?vue&type=script&setup=true&lang=js"

import "./AlphabetFilterComponent.vue?vue&type=style&index=0&id=4c7b98a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c7b98a6"]])

export default __exports__